import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ISupportCase } from '../../../shared';
import { ISupportCaseDuplicate } from '../../models';
import { DuplicateRow } from './duplicate-row.component';

interface Props {
    onClose?: () => void;
    supportCase?: ISupportCase;
    duplicates: ISupportCaseDuplicate[];
}
export const DuplicatesTable: FC<Props> = ({ onClose, supportCase, duplicates }) => {
    const { t } = useTranslation();
    return (
        <TableContainer sx={{ border: 1, borderColor: 'lightGrey', borderRadius: 1 }}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ width: '50px' }} />
                        <TableCell>{t('caseNumberLabel')}</TableCell>
                        <TableCell>{t('primarySupportee')}</TableCell>
                        <TableCell>{t('organisations')}</TableCell>
                        <TableCell>{t('reason')}</TableCell>
                        <TableCell sx={{ width: '100px' }} />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {supportCase &&
                        duplicates.map((row) => (
                            <DuplicateRow key={row.id} supportCase={supportCase} duplicate={row} onClose={onClose} />
                        ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
